import React from 'react';
import NotificationBell from '@/assets/icons/NotificationBell';
import { Link } from 'react-router-dom';
import ArrowRight from '@/assets/icons/ArrowRight';
import { formatNorwegianDate } from '@/utils/dates';

const ActivitiesList = ({ items }) => {
  if (!items || items.length === 0) return null;
  return (
    <div>
      <div className="flex items-center justify-between w-full">
        <div>
          <h3 className="text-xl font-medium">Aktivitet</h3>
          <p className="text-[15px] opacity-[65%]">
            Det siste som har skjedd i ditt Boligmappa-univers
          </p>
        </div>
        <Link
          className="border-b md:border-none border-b-[#333] h-[24px] leading-[27px] md:hover:underline"
          to="/personal-area/dashboard/notifications"
        >
          Se alle
        </Link>
      </div>
      <div className="mt-2">
        {items
          .reverse()
          .slice(0, 5)
          .map((el) => (
            <Link
              to={`/personal-area/dashboard/notifications/${el.id}`}
              key={el.id}
              className="flex items-center justify-between gap-4 py-4 border-b last:border-b-0 transition duration-300"
            >
              <div className="p-3 border rounded-lg bg-white">
                <NotificationBell />{' '}
              </div>
              <div className="w-full">
                <h4 className="text-base font-medium">{el.title}</h4>
                <p className="text-base opacity-[65%]">
                  {formatNorwegianDate(el.date)}
                </p>
              </div>
              <ArrowRight width="33" height="33" stroke="#22222266" />
            </Link>
          ))}
      </div>
      {/* {items.length > 5 && ( */}
      {/*   <Link */}
      {/*     to="/dashboard/notifications" */}
      {/*     className="opacity-[65%] border-b border-gray-500" */}
      {/*   > */}
      {/*     Se alle */}
      {/*   </Link> */}
      {/* )} */}
    </div>
  );
};

export default ActivitiesList;
